"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function mapValues(object, iteratee) {
  var result = {};

  Object.keys(object || {}).forEach(function (key) {
    result[key] = iteratee(object[key], key, object);
  });

  return result;
}

exports.default = mapValues;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-form/lib/utils/map-values.js
// module id = 55
// module chunks = 0